<script>
  import { ServiceScreen } from '../../../module_core/module_service'
</script>

<svelte:head>
  <title>Nossos serviços</title>

  <meta
    name="description"
    content="Os projetos da Lutruvials são a entrega de valor real, fazemos isso com total transparência não somente desenvolvemos software de qualidade mais fazemos você ter conhecimentos e dicas de como abrir um negócio no ecossistema digital, com um orçamento amigável e versátil."
  />

  <!-- Primary Meta Tags -->

  <!-- Open Graph / Facebook -->
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://lutruvials.com/" />
  <meta property="og:title" content="Nossos serviços" />
  <meta property="og:site_name" content="lutruvials" />
  <!-- prettier-ignore -->
  <meta property="og:description" content={'Os projetos da Lutruvials são a entrega de valor real, fazemos isso com total transparência não somente desenvolvemos software de qualidade mais fazemos você ter conhecimentos e dicas de como abrir um negócio no ecossistema digital, com um orçamento amigável e versátil.'} />
  <meta property="og:image" content="/jpeg/hero-banner.jpg" />

  <!-- X (Twitter) -->
  <meta property="twitter:card" content="/jpeg/hero-banner.jpg" />
  <meta property="twitter:url" content="https://lutruvials.com/" />
  <meta property="twitter:title" content="Nossos serviços" />
  <meta
    property="twitter:description"
    content={'Os projetos da Lutruvials são a entrega de valor real, fazemos isso com total transparência não somente desenvolvemos software de qualidade mais fazemos você ter conhecimentos e dicas de como abrir um negócio no ecossistema digital, com um orçamento amigável e versátil.'}
  />
  <meta property="twitter:image" content="/jpeg/hero-banner.jpg" />
</svelte:head>

<ServiceScreen />
